/**
 * Copyright © WarmHeart Intelligence Technology Group (Jiangsu) Co.,Ltd Company, Limited.
 * All Rights Reserved
 */
import url from "./conf";
import {post, tokenPost} from "./ajax";

const brand = {
  /**
   *  AJAX-获取品牌列表
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  list(success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST,
      {},
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-添加品牌
   * @param brandName
   * @param deliveryRatio
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  add(brandName,deliveryRatio, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.ADD_BRAND,
      {
        brandName: brandName,
        deliveryRatio: deliveryRatio,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-修改品牌
   * @param brandId
   * @param brandName
   * @param deliveryRatio
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  modify(brandId,brandName,deliveryRatio, success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.MODIFY_BRAND,
      {
        brandId: brandId,
        brandName: brandName,
        deliveryRatio: deliveryRatio,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
  /**
   *  AJAX-获取配送价系数修改列表
   *  @param brandId
   * @param success
   * @param fail
   * @param isLoadingExplicit
   * @param errorHandler
   */
  listLog(brandId,success, fail, isLoadingExplicit, errorHandler) {
    post.bind(this)(
      url.LIST_LOG,
      {
        brandId: brandId,
      },
      success,
      fail,
      isLoadingExplicit,
      errorHandler
    );
  },
}

export default brand;



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax-brand.js